module.exports = __webpack_public_path__ + "img/84000.b88f75c1.jpg";